export default __webpack_public_path__ + "static/media/cta-bg.4c6d4881.jpg";